/**
 * @description slotModifiers from SC, ideally this should be part of the form definition which can be configured by SC.
 * For now we keep a local reference
 * @type {string[]}
 *
 */
export const noneDefaultSlots = ['bottom-slot', 'modal-slot']

export const stickyDefaultSlot = 'show-as-sticky'
